import PreloadedAnimation from "../../app/PreloadedAnimation";
import store from "../../app/store";
import broadcast from "../../app/broadcast";
import utils from "../../app/utils";
import Evented from "../../app/Evented";


class SatelliteAnimation extends PreloadedAnimation{

    // constructor(layer) {
    //     super();
    //     this.layer = layer;
    //     this.evented = Evented.instance();
    //
    //     this.timeRange = store.get("satelliteRange");
    //
    //     const satelliteAnimation = this;
    //
    //     broadcast.on("preloadedtiles", function (progress) {
    //         if (! satelliteAnimation.paused)
    //             if (progress === "complete") {
    //                 this.loading=false;
    //                 satelliteAnimation.stepAnimation(0);
    //             } else {
    //                 satelliteAnimation.evented.emit("timeAnimationPercent", progress);
    //
    //             }
    //     });
    //
    //     broadcast.on("SatLayerMoveStart", function (){
    //         if(satelliteAnimation.playing ) {
    //             satelliteAnimation.stopAnimation();
    //         }
    //     });
    // }

    constructor(layer) {
        super(layer);
        this.timeFrame = 50;
    }

    getTimeRange(){
        return store.get("satelliteRange");
    }

    getCalendar(){
        return store.get("satelliteCalendar");
    }

    getTimestamp(){
        return store.get("satelliteTimestamp");
    }

    setTimestamp(timestamp){
        return store.set("satelliteTimestamp", timestamp);
    }

    // stepAnimation(timestamp){
    //
    //     // const calendar = this.getCalendar();
    //
    //     // Identificador de la animación
    //     if (this.playing && ! this.paused) {
    //         this.frameID = requestAnimationFrame(this.stepAnimation.bind(this));
    //     }
    //
    //     // Si no se ha inicializado el timestamp previo
    //     if (! this.prevtimestamp)
    //         this.prevtimestamp = timestamp;
    //
    //     // Tiempo transcurrido desde que se pintó el último frame
    //     const timeElapsed = timestamp - this.prevtimestamp;
    //
    //     if ( (this.currentTs !== this.endTs && timeElapsed >= 50) || (this.currentTs === this.endTs && timeElapsed >= 1000))
    //     {
    //         console.info(this.currentTs)
    //         // Se actualiza el timestamp previo
    //         this.prevtimestamp = timestamp;
    //
    //         this.currentTs += this.step;
    //         if (this.currentTs > this.endTs)
    //             this.currentTs = this.startTs;
    //
    //         // store.set("satelliteTimestamp", this.currentTs)
    //         this.setTimestamp(this.currentTs);
    //
    //         if ((this.currentTs - this.startTs) % this.printStep === 0)
    //             this.evented.emit("timeAnimationPrintTs", this.currentTs);
    //             // this.view.setProgressText(calendar.ts2hour(new Date(this.currentTs)));
    //
    //     }
    // }



    // startAnimation(loopsteps) {
    //     // const productSat = products["satellite"];
    //     if (! this.playing ) {
    //         this.playing = true;
    //
    //         const calendar = this.getCalendar();
    //         const animation = this;
    //         const timestamp = calendar.end - this.timeRange * 3600 * 1000;
    //
    //         const satTs = this.getTimestamp();
    //
    //         this.evented.emit("timeAnimationStart");
    //
    //         this.loading = true;
    //
    //         animation.startTs = timestamp;
    //         animation.endTs = calendar.end;
    //         animation.currentTs = satTs;
    //
    //         animation.step = ( this.timeRange < 12 ? 5 : 10 ) * 60 * 1000;
    //         animation.printStep = 10 * 60 * 1000;
    //
    //         this.layer.preload(timestamp < satTs ? timestamp : satTs, animation.step);
    //
    //     }
    //
    // }
    //
    // stopAnimation() {
    //     super.stopAnimation();
    //     this.evented.emit("timeAnimationStop");
    // }

}

export default SatelliteAnimation;
